import ReleaseService from "@/services/ReleaseService";
export const release = {
  namespaced: true,
  actions: {
    getAll: () => ReleaseService.getAll(),
    get: (_, id) => ReleaseService.get(id),
    save: (_, payload) => ReleaseService.save(payload.data, payload.update),
    remove: (_, id) => ReleaseService.remove(id),
    getPublic: (_, slug) => ReleaseService.getPublic(slug),
    getUnread: () => ReleaseService.getUnread(),
    markRead: () => ReleaseService.markRead(),
    getReleaseOData: (_, payload) => ReleaseService.getOData(payload),
    upload: (_, files) => ReleaseService.upload(files),
  },
};
export default release;
